export const getInfoFromKnowledgeQueryExtra = (knowledgeQueryExtra: string) => {
  if (!knowledgeQueryExtra) {
    return null;
  }

  // 第一次解析：解析 extra JSON 字符串
  try {
    const extraObj = JSON.parse(knowledgeQueryExtra) as Conversation.ExtraInfo;
    const itemInfoStr = extraObj?.itemInfo;
    const rewriteQuery = extraObj?.rewriteQuery;

    return {
      extraInfo: extraObj,
      itemInfo: itemInfoStr
        ? (JSON.parse(itemInfoStr) as Conversation.KnowledgeQueryMessageItemInfo)
        : null,
      rewriteQuery: rewriteQuery ?? '',
    };
  } catch (error) {
    console.error('解析 extra 失败:', error);
    return null;
  }
};
